import assetPath from '/opt/actions-runner/_work/crate/crate/packages/login/layout/src/background-layout/images/energizer.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')